export default __webpack_public_path__ + "static/media/114_krikkrok_kawai_0001.b5de215d.png";